@if(!spinning) {
<h2 mat-dialog-title> {{ labels.title }} </h2>
}
<mat-dialog-content class="container">
    @if(spinning) {
    <div class="loading-spinner-overlay">
        <mat-spinner></mat-spinner>
    </div>
    } @else {
    @if(this.repo.resource$ | async; as results) {
    @if (hasResults) {
    <lib-business-search-results-filter [order]="order" [showStatusDateFromFilter]="false" [showStatusDateToFilter]="false" [showJurisdictionStatusFilter]="false"
        [showDescriptionFilter]="false" [showCreationDateFromFilter]="false" [showCreationDateToFilter]="false" [showCompanyTypeFilter]="false"
        [labels]="{
            title: labels.buttons.filters,
            name: labels.nameColumnHeader,
            number: labels.numberColumnHeader,
            status: labels.statusColumnHeader,
            jurisdiction: labels.jurisdictionColumnHeader,
            filter: labels.buttons.filter,
            clearFilters: labels.buttons.clearFilters
        }">
    </lib-business-search-results-filter>
    }
    @if(results.length > 0) {
    <div class="table-container">
        <table mat-table matSort [dataSource]="buildTableRows(results)" (matSortChange)="sort($event)">

            <!-- Section header column (spans full width) -->
            <ng-container matColumnDef="sectionHeader">
                <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length" class="section-header-cell">
                    {{ row.label }}
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ labels.nameColumnHeader }}</th>
                <td mat-cell *matCellDef="let result">{{ result.name }}</td>
            </ng-container>

            <ng-container matColumnDef="number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ labels.numberColumnHeader }}</th>
                <td mat-cell *matCellDef="let result">{{ result.number }}</td>
            </ng-container>

            <ng-container matColumnDef="jurisdiction">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ labels.jurisdictionColumnHeader }}</th>
                <td mat-cell *matCellDef="let result">{{ getJurisdiction(result) }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ labels.statusColumnHeader }}</th>
                <td mat-cell *matCellDef="let result">{{ result.status }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <!-- Section header rows -->
            <tr mat-row *matRowDef="let row; columns: ['sectionHeader']; when: isGroupHeader" class="section-header-row"></tr>
            <!-- Data rows -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="pointer"
                [class.highlight]="selectedResult === row" (click)="onRowClick(row)" tabindex="0" (keydown.enter)="onRowClick(row)"></tr>
        </table>
    </div>
    } @else if(!spinning) {
        <div style="height:300px;" class="flex-container-center">
            @if(hasResults) {
            <lib-placeholder iconName="warning" iconClass="icon-info" [message]="labels.noResultsFilters" [condition]="true"></lib-placeholder>
            } @else {
            <lib-placeholder iconName="cloud_off" iconClass="icon-info" [message]="labels.noResults" [condition]="true"></lib-placeholder>
            }
        </div>
    }
    @if(((this.repo.resourceCount$ | async) ?? 0) > 10) {
    <mat-paginator [pageSize]="this.repo.pageSize$ | async" [length]="this.repo.resourceCount$ | async"
        [pageIndex]="this.repo.pageNum$ | async" [pageSize]="10" showFirstLastButtons="true" (page)="page($event)">
    </mat-paginator>
    <div class="spacer-small"></div>
    }
    }
    }
</mat-dialog-content>

@if(!spinning) {
<mat-dialog-actions>
    <div class="spacer"></div>
    <div class="flex-container-right-align">
        <button class="margin-sides-5" [mat-dialog-close]="undefined" color="warn" mat-raised-button>{{ labels.buttons.close }}</button>
        <button class="margin-sides-5" [disabled]="!selectedResult" [mat-dialog-close]="selectedResult"
            color="primary" mat-raised-button>{{ labels.buttons.select }}</button>
        </div>
</mat-dialog-actions>
}
